<template>
  <div class="EditAddMarketplace">
    <el-form v-loading="loadingPage" :model="ruleForm" ref="ruleForm" :rules="rules" @submit.prevent v-on:submit.prevent>
      <HeaderPage>
        <el-button style="height: 44px; margin-left: 1rem" native-type="submit" @click.prevent="submitForm('ruleForm')">Salvar</el-button>
        <el-dropdown v-if="ruleForm.id" trigger="click" @command="handleAction">
          <el-button type="text" icon="el-icon-more" class="el-dropdown-link"></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="ruleForm.logistics_group !== null" command="ASSOGRUPOLOJISTA">Sincronizar grupo de lojistas</el-dropdown-item>
            <el-dropdown-item command="alter_type">Alterar Tipo de Cliente</el-dropdown-item>
            <el-dropdown-item icon="el-icon-delete" divided command="DELETE">Excluir</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </HeaderPage>
      <el-dialog
          :visible.sync="dialogVisible"
          width="30%">
        <el-form v-loading="loadingPageDialog" :model="ruleFormType" ref="ruleFormType" :rules="rules" @submit.prevent v-on:submit.prevent>
          <el-form-item prop="type" label="Tipo">
            <el-select v-model="ruleFormType.type" style="width: 100%">
              <el-option label="Representante" value="agent" />
              <el-option label="Estabelecimento Comercial" value="ec" />
            </el-select>
          </el-form-item>
          <el-form-item prop="change_marketplace_id" label="Marketplace que será substituido nas associações">
            <SelectSearchMarketplace :model="ruleFormType.change_marketplace_id" :isEdit="false" @handleValue=" (x) => { ruleFormType.change_marketplace_id = x } "  />
          </el-form-item>
          <el-form-item prop="associate_marketplace_id" label="Marketplace que será associado ao novo Representante ou EC">
            <SelectSearchMarketplace :model="ruleFormType.associate_marketplace_id" :isEdit="false" @handleValue=" (x) => { ruleFormType.associate_marketplace_id = x } "  />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">Cancelar</el-button>
            <el-button type="primary" @click="submitChangeType">Alterar</el-button>
          </span>
      </el-dialog>
      <el-card shadow="never" :body-style="{ padding: '0px' }" style="background-color: transparent; border: none">
        <el-tabs v-model="activeNameTabs" type="card" style="margin: 20px auto 0 auto;max-width: 1300px;">
          <el-tab-pane label="Geral" name="1">
            <el-row :gutter="20">
              <el-col :lg="8" :sm="8" :xs="24">
                <el-form-item prop="marketplace_manager_id" label="Gerente de marketplaces" >

                <SelectSearchGerenteMarketplace :disabled="$can('6')" :model="ruleForm.marketplace_manager_id" :isEdit="false" @handleValue=" (x) => { ruleForm.marketplace_manager_id = x } "  />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :sm="8" :xs="24">
                <el-form-item prop="name" label="Nome do Proprietário" :error="error.name">
                  <el-input size="large" v-model="ruleForm.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="6" :sm="6" :xs="24">
                <el-form-item prop="slug" label="Slug" :error="error.slug">
                  <el-input size="large" maxlength="15" show-word-limit v-model="ruleForm.slug">
                    <el-tooltip
                      slot="suffix" class="item" effect="dark" placement="top">
                      <div slot="content" style="text-align: center">
                        Slug é a parte de uma URL para identificar sua empresa. <br>
                        Não pode conter caracteres especiais e nem espaços entre palavras.
                      </div>
                      <i class="el-icon-question el-input__icon" />
                    </el-tooltip>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="5" :sm="5" :xs="24">
                <el-form-item prop="birthday" label="Data de nascimento" :error="error.birthday">
                  <el-date-picker style="width: 100%;" format="dd/MM/yyyy" value-format="yyyy-MM-dd" v-model="ruleForm.birthday" type="date" />
                </el-form-item>
              </el-col>
              <el-col :lg="5" :sm="5" :xs="24">
                <el-form-item prop="gender" label="Género" :error="error.gender">
                  <el-select v-model="ruleForm.gender" clearable style="width: 100%">
                    <el-option label="Masculino" value="male" />
                    <el-option label="Feminino" value="female" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :lg="8" :sm="8" :xs="24">
                <el-form-item prop="cpf" label="CPF" :error="error.cpf">
                  <el-input masked="true" size="large" v-model="ruleForm.cpf" v-mask="'###.###.###-##'" required />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :sm="8" :xs="24">
                <el-form-item prop="rg" label="RG" :error="error.rg">
                  <el-input masked="true" size="large" v-model="ruleForm.rg" v-mask="'##.###.###-#'" required />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :sm="8" :xs="24">
                <el-form-item prop="type_person" label="Tipo de pessoa" :error="error.type_person">
                  <el-select v-model="ruleForm.type_person" clearable style="width: 100%">
                    <el-option label="Empresa" value="business" />
                    <!-- <el-option label="Individual" value="individual" /> -->
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-divider content-position="left">Contato</el-divider>
            <el-row :gutter="20">
              <el-col :lg="6" :sm="6" :xs="24">
                <el-form-item prop="type_contact" label="Tipo do Contato" :error="error.type_contact">
                  <el-select v-model="ruleForm.type_contact" clearable style="width: 100%">
                    <el-option label="Pessoal" value="personal" />
                    <el-option label="Empresa" value="business" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="6" :sm="6" :xs="24">
                <el-form-item prop="phone_operator_id" label="Operadora de telefone" :error="error.phone_operator_id">
                  <SelectSearchPhoneOperator :model="ruleForm.phone_operator_id" :isEdit="isEdit" @handleValue="(x) => {ruleForm.phone_operator_id = x}"  />
                </el-form-item>
              </el-col>

              <el-col :lg="6" :sm="6" :xs="24">
                <el-form-item prop="phone" label="Telefone">
                  <el-input masked="true" size="large" v-model="ruleForm.phone" v-mask="['(##) #####-####', '(##) ####-####']" required />
                </el-form-item>
              </el-col>
              <el-col :lg="6" :sm="6" :xs="24">
                <el-form-item prop="email" label="E-mail">
                  <el-input type="email" size="large" v-model="ruleForm.email" required />
                </el-form-item>
              </el-col>
            </el-row>
            <div>
              <el-divider content-position="left">Empresa</el-divider>
              <el-row :gutter="20">
                <el-col :lg="12" :sm="12" :xs="24">
                      <el-form-item prop="name_store" label="Nome do Marketplace" :error="error.name_store">
                        <el-input size="name_store" v-model="ruleForm.name_store"></el-input>
                      </el-form-item>
                    </el-col>
              </el-row>
              <el-row :gutter="20" v-if="this.ruleForm.type_person === 'business'">
                <el-col :lg="24" :sm="24" :xs="24">
                  <el-row :gutter="20">
                    <el-col :lg="12" :sm="12" :xs="24">
                      <el-form-item prop="business_cnpj" label="CNPJ" :error="error.business_cnpj">
                        <el-input masked="true" size="large" v-model="ruleForm.business_cnpj" v-mask="'##.###.###/####-##'" required />
                      </el-form-item>
                    </el-col>
                    <el-col :lg="6" :sm="6" :xs="24">
                      <el-form-item prop="business_date" label="Data de abertura da empresa" :error="error.business_date">
                        <el-date-picker style="width: 100%;" format="dd/MM/yyyy" value-format="yyyy-MM-dd" v-model="ruleForm.business_date" type="date" />
                      </el-form-item>
                    </el-col>
                    <el-col :lg="6" :sm="6" :xs="24">
                      <el-form-item prop="mcc_id" label="Ramo de negócio" :error="error.mcc_id">
                        <SelectSearchMCC :model="ruleForm.mcc_id" :isEdit="isEdit" @handleValue="(x) => {ruleForm.mcc_id = x}"  />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :lg="12" :sm="12" :xs="24">
                      <el-form-item prop="business_name" label="Razão Social da empresa" :error="error.business_name">
                        <el-input size="business_name" v-model="ruleForm.business_name"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                     <el-col :lg="24" :md="24" :xs="24">
                        <el-form-item prop="type_business_id" label="Tipo de negócio" :rules="[{required: true, message: 'Requerido', trigger: 'blur'}]">
                          <SelectSearchTypeBusiness :model="ruleForm.type_business_id" :isEdit="isEdit" @handleValue=" (x) => { ruleForm.type_business_id = x } " />
                        </el-form-item>
                      </el-col>
                  </el-row>

                  <el-form-item prop="business_description" label="Descrição/Observações da empresa" :error="error.business_description">
                    <el-input
                      type="textarea"
                      :rows="2"
                      v-model="ruleForm.business_description">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <el-divider content-position="left">Custos Operacionais</el-divider>

            <el-row :gutter="20">
              <el-col :lg="12" :sm="12" :xs="24">
                <SelectSearchCustoOpera :model="ruleForm.cost_plan_id" :isEdit="false" @handleObjValue="(x) => {listDataCustoOpera = {data: [x]}}" @handleValue="(x) => {$set(ruleForm, 'cost_plan_id', x)}" />
              </el-col>
            </el-row>
            <TableSimple v-if="listDataCustoOpera.data" :list-data="listDataCustoOpera">
              <el-table-column prop="name" label="Nome">
              </el-table-column>
              <el-table-column prop="cost_per_transactions" label="Custo por transação">
              </el-table-column>
              <el-table-column prop="monthly_payment" label="Custo da mensalidade">
              </el-table-column>
            </TableSimple>
          </el-tab-pane>
          <el-tab-pane :disabled="!isEdit" label="Endereço" name="address">
            <el-row :gutter="20">
              <el-col :lg="12" :md="12">
                <el-form-item prop="postal_code" label="CEP" :error="error.postal_code">
                  <el-input masked="true" size="large" v-mask="['#####-###']" v-model="ruleForm.postal_code" required></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="12" :sm="12" :xs="24">
                <el-form-item prop="type_address" label="Tipo de Endereço" :error="error.type_address">
                  <el-select v-model="ruleForm.type_address" clearable style="width: 100%">
                    <el-option label="Empresa" value="business" />
                    <el-option label="Pessoal" value="personal" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :lg="18" :md="18">
                <el-form-item prop="street" label="Endereço" :error="error.street">
                  <el-input size="large" v-model="ruleForm.street" required>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="6" :md="6">
                <el-form-item prop="number" label="Nº" :error="error.number">
                  <el-input size="large" v-model="ruleForm.number" required>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item prop="complement" label="Complemento" :error="error.complement">
              <el-input size="large" v-model="ruleForm.complement" required>
              </el-input>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :lg="8" :md="8">
                <el-form-item prop="neighborhood" label="Bairro" :error="error.neighborhood">
                  <el-input size="large" v-model="ruleForm.neighborhood" type="text" required/>
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="8">
                <el-form-item prop="city_id" label="Cidade" :error="error.city_id">
                  <el-select
                    size="large"
                    v-model="ruleForm.city_id"
                    style="width: 100%;"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="Pesquise a Cidade"
                    :remote-method="serchCity"
                    :loading="loadingCity">
                    <el-option v-for="(item, index) in cityOptions" :key="index" :label="item.title" :value="item.id">
                      <span style="float: left">{{ item.title }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">DDD {{ item.iso_ddd }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="8">
                <el-form-item prop="state_id" label="Estado" :error="error.state_id">
                  <el-select
                    size="large"
                    v-model="ruleForm.state_id"
                    style="width: 100%;"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="Pesquise o Estado"
                    :remote-method="serchState"
                    :loading="loadingCity">
                    <el-option v-for="(item, index) in StateOptions" :key="index" :label="item.title" :value="item.id">
                      <span style="float: left">{{ item.title }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.letter }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane :disabled="!isEdit" label="Planos" name="plans">
            <PlanosMarketplaces />
          </el-tab-pane>
          <el-tab-pane :disabled="!isEdit" label="Logotipo" name="logo">
            <el-row :gutter="20">
              <el-col :lg="6" :sm="6" :xs="24">
                <div v-loading="loadingUpImage">
                  <label  class="el-form-item__label" style="width: 100%;text-align: left;">Logo</label>
                  <el-upload
                    name="image"
                    style="width: 100%"
                    class="avatar-uploader"
                    :action="urlPostImage.url[0]"
                    :headers="urlPostImage.headers"
                    :show-file-list="false"
                    :auto-upload="autoUploadImage"
                    :on-change="handleChange"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload">
                    <img v-if="urlImage" :src="urlImage" style="width: 100%; height: 100%; display: block;">
                    <i v-else class="el-icon-plus avatar-uploader-icon" style="width: 100%; height: 100%;"></i>
                  </el-upload>
                </div>
              </el-col>
              <el-col :lg="18" :sm="18" :xs="24">
                <el-form-item prop="color_primary" label="Cor Primaria">
                  <el-color-picker style="width: 100%;" v-model="ruleForm.color_primary"></el-color-picker>
                </el-form-item>
                <el-form-item prop="color_secondary" label="Cor Secundaria">
                  <el-color-picker style="width: 100%;" v-model="ruleForm.color_secondary"></el-color-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-divider />
            <el-row :gutter="20">
              <el-col :lg="6" :sm="6" :xs="24">
                <div v-loading="loadingUpbanner">
                  <label  class="el-form-item__label" style="width: 100%;text-align: left;">Banner</label>
                  <el-upload
                      name="banner"
                      style="width: 100%"
                      class="avatar-uploader"
                      :action="urlPostImage.url[1]"
                      :headers="urlPostImage.headers"
                      :show-file-list="false"
                      :auto-upload="autoUploadImage"
                      :on-change="handleChangeBanner"
                      :before-upload="beforeAvatarUpload">
                    <img v-if="urlImageBanner" :src="urlImageBanner" style="width: 100%; height: 100%; display: block;">
                    <i v-else class="el-icon-plus avatar-uploader-icon" style="width: 100%; height: 100%;"></i>
                  </el-upload>
                </div>
              </el-col>
              <el-col :lg="18" :sm="18" :xs="24">
                <el-form-item prop="title_login" label="Titulo">
                  <el-input size="large" v-model="ruleForm.title_login"></el-input>
                </el-form-item>
                <el-form-item prop="description_login" label="Descrição">
                  <el-input size="large" type="textarea" :rows="2" v-model="ruleForm.description_login"></el-input>
                </el-form-item>
                <el-form-item prop="url_button_login" label="Link (Saiba mais)">
                  <el-input size="large" type="url" v-model="ruleForm.url_button_login"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane :disabled="!isEdit" label="Dados Bancários" name="bank">
            <BankMKTComercial v-if="activeNameTabs === 'bank'" :ruleF="ruleForm" />
          </el-tab-pane>
          <el-tab-pane :disabled="!isEdit" label="Taxa de Antecipação" name="anticipation_fee">
            <el-row :gutter="20">
              <el-col :lg="24" :md="24">
                <el-form-item prop="anticipation_fee" label="Taxa (%)" :error="error.anticipation_fee">
                  <el-input size="large" @input="filterNonValueAnticipationFee" v-model="ruleForm.anticipation_fee" required></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" >
              <el-col :lg="24" :md="24">
                <el-form-item prop="anticipation_fee" label="Taxa Cappta (%)" :error="error.anticipation_fee">
                  <el-input :disabled="$can('6')" size="large" @input="filterNonValueAnticipationBaseFee" v-model="ruleForm.anticipation_base_fee" required></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-form>
  </div>
</template>

<script>
import SelectSearchMarketplace from "@/app/components/Marketplace/SelectSearchMarketplace";

var listDataCustoOpera;

import HeaderPage from "@/app/components/HeaderPage";
import SelectSearchPhoneOperator from "@/app/components/PhoneOperator/SelectSearchPhoneOperator";
import SelectSearchTypeBusiness from "@/app/components/TypeBusiness/SelectSearchTypeBusiness";
import {api as configs} from "@/app/config";
import {
  deleteMarketplaces,
  getMarketplaces, postChangeTypeMarketplaces,
  postMarketplaces,
  putMarketplaces

} from "@/app/domains/Records/services";
import {getCity, getState, postSyncLogista} from "@/app/domains/Config/services";
import {
  clearRuleForm,
  getErrorFilds,
  makeErrorFilds,
  toSlug,
  validateCNPJ,
  validateCPF,
  validateEmail
} from "@/app/plugins/utils";
import SelectSearchMCC from "@/app/components/MCC/SelectSearchMCC";
import {mapGetters} from "vuex";
import PlanosMarketplaces from "@/app/domains/Records/components/Marketplaces/PlanosMarketplaces";
import GrupoLojita from "@/app/domains/Records/components/Marketplaces/GrupoLojita";
import BankMKTComercial from "@/app/domains/Records/components/Marketplaces/BankMKTComercial";
import SelectSearchCustoOpera from "@/app/components/CustosOperacionais/SelectSearchCustoOpera";
import SelectSearchGerenteMarketplace from "@/app/components/GerenteMarketplace/SelectSearchGerenteMarketplace";
import TableSimple from "@/app/components/Table/TableSimple";

export default {
  name: "EditAddMarketplace",
  components: {
    HeaderPage,
    SelectSearchPhoneOperator,
    SelectSearchMCC,
    PlanosMarketplaces,
    SelectSearchTypeBusiness,
    BankMKTComercial,
    SelectSearchCustoOpera,
    TableSimple,
    SelectSearchMarketplace,
    SelectSearchGerenteMarketplace
  },
  data() {
    var checkSlug = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Requerido'));
      }
      let regex = /^(?=.*[@!#$%^&*()=+¨ /\\])/;
      // let regex = /^(?=.*[@!#$%^&*()/\\])[@!#$%^&*()/\\a-zA-Z0-9]$/;
      
      if (regex.test(value)) {
        callback(new Error('Não pode ter caractere especial.'));
      }
      callback()
    };
    return {
      listDataCustoOpera: {},
      ruleFormType: {
        type: '',
        marketplace_id: this.$route.params.id,
      },
      valueType: '',
      activeNameTabs: "1",
      loadingPageDialog: false,
      dialogVisible: false,
      loadingUpImage: false,
      loadingUpbanner: false,
      loadingPage: false,
      loadingCity: false,
      urlImage: '',
      urlImageBanner: '',
      cityOptions: [],
      StateOptions: [],
      error: {},
      ruleForm: {
        name: '',
        slug: '',
        type_person: '',
        cpf: '',
        rg: '',
        birthday: '',
        gender: '',
        type_contact: '',
        phone_operator_id: '',
        phone: '',
        email: '',
        business_cnpj: '',
        name_store: '',
        business_name: '',
        business_date: '',
        mcc_id: '',
        business_description: '',
        color_primary: '',
        color_secondary: '',
        country_code: '55',
        type_business_id: 2,
        cost_plan_id: '',
        marketplace_manager_id:'',
        anticipation_fee: '',
        anticipation_base_fee: '',
      },
      rules: {
        name: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        slug: [
          {validator: checkSlug, trigger: 'blur'}
        ],
        birthday: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        cpf: [
          {required: true, message: 'Requerido', trigger: 'blur'},
          { validator: this.cpfVerify, trigger: "blur"}
        ],
        email: [
          {required: true, message: 'Requerido', trigger: 'blur'},
          { validator: this.emailVerify, trigger: "blur"}
        ],
        gender: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        mcc_id: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        name_store: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        phone_operator_id: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        type_contact: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        type_person: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        business_cnpj: [
          {required: true, message: 'Requerido', trigger: 'blur'},
          { validator: this.cnpjVerify, trigger: "blur"}
        ],
        business_date: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        business_name: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
      },
    }
  },
  computed: {
    ...mapGetters('Auth', ['getToken', 'currentUser']),
    urlPostImage: function () {
      return {
        url: [
          `${configs.baseUrl}import/logo/marketplace/${this.ruleForm.id}`,
          `${configs.baseUrl}import/banner/marketplace/${this.ruleForm.id}`
        ],
        headers: {
          Authorization: 'Bearer ' + this.getToken
        }
      }
    },
    autoUploadImage: function () {
      return (this.ruleForm.id) ? true : false
    },
    isEdit: function () {
      return !!(this.ruleForm.id)
    },
  },
  methods: {
    filterNonValueAnticipationFee() {
      let newValue = this.ruleForm.anticipation_fee.replace(/[^0-9,]/g, '');

      let value = parseFloat(newValue.replace(',', '.'));

      let otherValue = parseFloat(this.ruleForm.anticipation_base_fee.replace(',', '.'));

      let sum = value + otherValue;
      
      if (sum > 100) {
        newValue = (100 - otherValue).toFixed(2).toString();
        this.$message({
          showClose: true,
          message: 'O valor foi ajustado para não ultrapassar 100%.',
          type: 'error'
        })
      }

      if (this.ruleForm.anticipation_fee !== newValue) {
        this.ruleForm.anticipation_fee = this.formatReal(newValue)
      }
    },

    filterNonValueAnticipationBaseFee() {
      let newValue = this.ruleForm.anticipation_base_fee.replace(/[^0-9,]/g, '');

      let value = parseFloat(newValue.replace(',', '.'));

      let otherValue = parseFloat(this.ruleForm.anticipation_fee.replace(',', '.'));

      let sum = value + otherValue;
      
      if (sum > 100) {
        newValue = (100 - otherValue).toFixed(2).toString();
        this.$message({
          showClose: true,
          message: 'O valor foi ajustado para não ultrapassar 100%.',
          type: 'error'
        })
      }

      if (this.ruleForm.anticipation_base_fee !== newValue) {
        this.ruleForm.anticipation_base_fee = this.formatReal(newValue)
      }
    },
    formatReal(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "decimal",
        currency: "BRL",
        minimumFractionDigits: 2,
      }).format(value);
    },
    async serchCity(query) {
      if (query.length > 2) {
        this.loadingCity = true
        try {
          let response = await getCity('?name=' + query)
          this.cityOptions = response.data.data
          this.$set(this.ruleForm, 'country_code', 55)
        } catch (e) {
          this.$message({
            showClose: true,
            message: e.body.error.message,
            type: 'error'
          })
        } finally {
          this.loadingCity = false
        }
      }
    },
    async serchState(query) {
      if (query.length > 2) {
        this.loadingCity = true
        try {
          let response = await getState('?name=' + query)
          this.StateOptions = response.data.data
        } catch (e) {
          
          this.$message({
            showClose: true,
            message: e.body.error.message,
            type: 'error'
          })
        } finally {
          this.loadingCity = false
        }
      }
    },
    cpfVerify (rule, value, callback) {
      if (validateCPF(this.ruleForm.cpf)) {
        callback()
      } else {
        callback(new Error('CPF Invalido'))
      }
    },
    cnpjVerify (rule, value, callback) {
      if (validateCNPJ(this.ruleForm.business_cnpj)) {
        callback()
      } else {
        callback(new Error('CNPJ Invalido'))
      }
    },
    emailVerify (rule, value, callback) {
      if (validateEmail(this.ruleForm.email)) {
        callback()
      } else {
        callback(new Error('Email Invalido'))
      }
    },
    submitForm(ruleForm) {
      this.$refs[ruleForm].validate(async (valid, i) => {
        if (valid) {
          this.error = []
          try {
            this.loadingPage = true
            let response;
            if (this.ruleForm.id !== undefined) {
              this.$set(this.ruleForm, 'country_code', 55)
              this.ruleForm.anticipation_fee = this.ruleForm.anticipation_fee.replace('.', '');
              this.ruleForm.anticipation_fee = this.ruleForm.anticipation_fee.replace(',', '.');
              this.ruleForm.anticipation_base_fee = this.ruleForm.anticipation_base_fee.replace('.', '');
              this.ruleForm.anticipation_base_fee = this.ruleForm.anticipation_base_fee.replace(',', '.');
              await putMarketplaces(clearRuleForm(this.ruleForm))
              this.$message({
                showClose: true,
                message: 'Editado com Sucesso',
                type: 'success'
              })
              await this.$router.push({name: 'records.marketplaces.index'})
            } else {
              await postMarketplaces(this.ruleForm)
              this.$message({
                showClose: true,
                message: 'Adicionado com sucesso',
                type: 'success'
              })
              await this.$router.push({name: 'records.marketplaces.index'})
            }
          } catch (e) {
            this.error = getErrorFilds(e)
            this.activeNameTabs = "address"
            this.$message({
              showClose: true,
              message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
              type: 'error'
            })
          } finally {
            this.loadingPage = false
          }
        } else {
          
          for (let [key, value] of Object.entries(i)) {
            this.$notify.error({
              message: 'Campo: ' + key + ' é Requerido'
            });
          }
        }
      })
    },
    handleChangeBanner(file) {
      this.loadingUpbanner = true
      this.urlImageBanner = URL.createObjectURL(file.raw);
      // this.rawImage = file.raw
      // this.ruleForm.image = file.raw
      this.loadingUpbanner = false
    },
    submitChangeType() {
      this.$confirm('Deseja alterar o tipo desse Marketplace?', 'Atenção', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar',
        center: true,
        type: 'warning'
      }).then(async () => {
        try {
          await postChangeTypeMarketplaces(this.ruleFormType)
          this.$message({
            showClose: true,
            message: 'Alterado com sucesso',
            type: 'success'
          })
          await this.$router.push({name: 'records.marketplaces.index'})
        } catch (e) {
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: 'error'
          })
        } finally {
          this.loadingPage = false
        }
      }).catch(() => {
        this.loadingPage = false
      });
    },
    handleChange(file) {
      
      this.loadingUpImage = true
      this.urlImage = URL.createObjectURL(file.raw);
      this.rawImage = file.raw
      // this.ruleForm.image = file.raw
      this.loadingUpImage = false
    },
    handleAvatarSuccess(res, file) {
      this.ruleForm.image = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isJPG) {
      //   this.$message.error('Avatar picture must be JPG format!');
      // }
      if (!isLt2M) {
        this.$message.error('Avatar picture size can not exceed 2MB!');
      }
      return isLt2M;
    },
    async handleAction(act) {
      if (act === 'DELETE') {
        this.loadingPage = true
        this.$confirm('Deseja realmente deletar este Marketplace?', 'Atenção', {
          confirmButtonText: 'Sim',
          cancelButtonText: 'Cancelar',
          center: true,
          type: 'warning'
        }).then(async () => {
          try {
            await deleteMarketplaces(this.ruleForm.id)
            await this.$router.push({name: 'records.marketplaces.index'})
            this.$message({
              showClose: true,
              message: 'Marketplace foi excluido.',
              type: 'success'
            })
          } catch (e) {
            this.$message({
              showClose: true,
              message: e.data,
              type: 'error'
            })
          } finally {
            this.loadingPage = false
          }
        }).catch(() => {
          this.loadingPage = false
        });
      } else if (act === 'ASSOGRUPOLOJISTA') {
        this.loadingPage = true
        this.$confirm('Deseja Sincronizar o grupo de lojistas?', 'Atenção', {
          confirmButtonText: 'Sim',
          cancelButtonText: 'Cancelar',
          center: true,
          type: 'warning'
        }).then(async () => {
          try {
            await postSyncLogista(this.ruleForm.logistics_group.id)
            this.$message({
              showClose: true,
              message: 'Grupo de lojistas sincronizado',
              type: 'success'
            })
          } catch (e) {
            this.error = getErrorFilds(e)
            this.$message({
              showClose: true,
              message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
              type: 'error'
            })
          } finally {
            this.loadingPage = false
          }
        }).catch(() => {
          this.loadingPage = false
        });
      } else if (act === 'alter_type') {
        this.dialogVisible = true
      }
    },
  },
  async mounted() {
    if (this.$can("6")) {
      this.ruleForm.marketplace_manager_id = this.currentUser.marketplace_manager_id;
    }
    try {
      if (this.$route.params.id) {
        this.loadingPage = true
        let response = await getMarketplaces(`/${this.$route.params.id}`)
        
        this.urlImage = response.data.uri_logo
        this.ruleForm = response.data.person
        this.$set(this.ruleForm, 'slug', response.data.slug)
        this.$set(this.ruleForm, 'logistics_group', response.data.logistics_group)
        this.$set(this.ruleForm, 'person_id', response.data.person_id)
        this.$set(this.ruleForm, 'cost_plan_id', response.data.cost_plan_id)

        this.$set(this.ruleForm, 'color_primary', response.data.color_primary)
        this.$set(this.ruleForm, 'color_secondary', response.data.color_secondary)
        this.$set(this.ruleForm, 'phone', response.data.person.contact.phone)
        this.$set(this.ruleForm, 'phone_operator_id', response.data.person.contact.phone_operator_id)
        this.$set(this.ruleForm, 'type_contact', response.data.person.contact.type_contact)
        this.$set(this.ruleForm, 'email', response.data.person.contact.email)
        this.$set(this.ruleForm, 'id', response.data.id)
        this.$set(this.ruleForm, 'marketplace_manager_id', response.data.marketplace_manager_id)
        this.$set(this.ruleForm, 'title_login', response.data.title_login)
        this.$set(this.ruleForm, 'description_login', response.data.description_login)
        this.$set(this.ruleForm, 'url_button_login', response.data.url_button_login)
        this.$set(this.ruleForm, 'banner_login', response.data.banner_login)
        this.urlImageBanner = response.data.banner_login

        if (response.data.person.type_person === "business") {
          this.$set(this.ruleForm, 'business_cnpj', response.data.person.business[0].business_cnpj)
          this.$set(this.ruleForm, 'business_date', response.data.person.business[0].business_date)
          this.$set(this.ruleForm, 'business_description', response.data.person.business[0].business_description)
          this.$set(this.ruleForm, 'business_name', response.data.person.business[0].business_name)
          this.$set(this.ruleForm, 'type_business_id', response.data.person.business[0].type_business_id)
        }

        if (response.data.person.address) {
          this.$set(this.ruleForm, 'postal_code', response.data.person.address.postal_code)
          this.$set(this.ruleForm, 'street', response.data.person.address.street)
          this.$set(this.ruleForm, 'number', response.data.person.address.number)
          this.$set(this.ruleForm, 'complement', response.data.person.address.complement)
          this.$set(this.ruleForm, 'neighborhood', response.data.person.address.neighborhood)
          if (response.data.person.address.city !== null) {
            this.cityOptions = [response.data.person.address.city]
            this.$set(this.ruleForm, 'city_id', response.data.person.address.city?.id)
            this.StateOptions = [response.data.person.address.state]
            this.$set(this.ruleForm, 'state_id', response.data.person.address.state?.id)
          }

          this.$set(this.ruleForm, 'type_address', response.data.person.address.type_address)
        }

        this.$set(this.ruleForm, 'anticipation_fee', this.formatReal(response.data.anticipation_fee))
        this.$set(this.ruleForm, 'anticipation_base_fee', this.formatReal(response.data.anticipation_base_fee))
       
        delete this.ruleForm.contact
        delete this.ruleForm.person
        delete this.ruleForm.mcc
        delete this.ruleForm.document
        delete this.ruleForm.bank_account
      }
    } catch (e) {
      
      this.error = getErrorFilds(e)
      this.$message({
        showClose: true,
        message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
        type: 'error'
      })
    } finally {
      this.loadingPage = false
    }
  }
}
</script>

<style scoped>

</style>
